import { useAuth } from '@clerk/clerk-react'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { APP_BASE_PATH } from '@/app.const'
import { rootRoutes } from '@/routes/org-routes.const'

import { LoadingScreen } from './loading-screen.atom'

interface ProtectedRouteProps {
  children: ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps): ReactNode => {
  const { isLoaded, isSignedIn } = useAuth()
  const location = useLocation()

  if (!isLoaded) {
    return <LoadingScreen />
  }

  if (!isSignedIn) {
    return (
      <Navigate
        to={`/${rootRoutes.signIn}`}
        state={{ from: `${APP_BASE_PATH}${location.pathname}${location.search}` }}
        replace
      />
    )
  }

  return <>{children}</>
}
